import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPanelRightSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M7 1L14 8L7 15M2 1L9 8L2 15"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgPanelRightSmall.displayName = 'SvgPanelRightSmall';
const PanelRightSmall = withForgeIconProps(SvgPanelRightSmall, {
  name: 'PanelRight',
  usage: 'Use to open a panel to the right.',
  related: 'flyout, pane',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default PanelRightSmall;
